/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const validateWiqlRequestSchema = z.object({
  projectName: z.string().min(1),
  wiql: z.string().min(1),
});
